/** Classes for a primary page-level CTA (e.g. "+ New review").
 *
 * Below sm (640px) the button collapses to a smaller square icon. At sm+ it
 * expands to the labeled control. Radius stays rounded-xl at every breakpoint.
 * Pair with pageActionLabelClassName on the text node and supply aria-label /
 * title equal to the label text. */
export const pageActionButtonClassName =
  "h-8 w-8 shrink-0 justify-center gap-0 rounded-xl p-0 [&_svg]:!size-3.5 sm:h-10 sm:w-auto sm:gap-2 sm:px-5 sm:[&_svg]:!size-4";

/** Hide the label on mobile; show it from sm upward. */
export const pageActionLabelClassName = "sr-only sm:not-sr-only sm:inline";

/** Hide header/page action controls on mobile; show from sm upward. */
export const pageActionDesktopOnlyClassName = "hidden sm:inline-flex";

/** Hide page/sheet header description on mobile; show from sm upward. */
export const pageDescriptionMobileHiddenClassName = "hidden sm:block";

/** Wrapper for page header action buttons — inline on mobile; light-mode grouped bg when 2+ buttons. */
export const pageActionGroupClassName =
  "flex shrink-0 flex-wrap items-center justify-end gap-1.5 sm:gap-2 " +
  "max-sm:[&:has(>:nth-child(2))]:rounded-xl max-sm:[&:has(>:nth-child(2))]:border max-sm:[&:has(>:nth-child(2))]:border-[var(--lm-border-subtle)] max-sm:[&:has(>:nth-child(2))]:bg-[var(--surface-sunken)] max-sm:[&:has(>:nth-child(2))]:p-1 " +
  "dark:max-sm:[&:has(>:nth-child(2))]:border-transparent dark:max-sm:[&:has(>:nth-child(2))]:bg-transparent dark:max-sm:[&:has(>:nth-child(2))]:p-0";
